import React from "react";

import images from "@/utils/images";

export function NewNoteItem({ iconPath, iconStyle, onClick, subTitle, title, ...liProps }) {
  return (
    <li
      className="pointer tw:flex tw:items-center tw:justify-between tw:gap-2.5"
      onClick={onClick}
      {...liProps}
    >
      <div className="tw:flex tw:w-full tw:max-w-4/5 tw:items-center tw:gap-2.5">
        <img
          alt="note icon"
          className="note-icon tw:aspect-square tw:w-10"
          src={images(iconPath)}
          style={iconStyle}
        />

        <div
          className="tw:flex tw:flex-col tw:justify-center"
          data-e2e="MemberProfileNotes_createGuidedSessionNote"
        >
          <p className="fs-16 mb-0 tw:font-bold">{title}</p>
          {subTitle && <p className="mb-0 fs-14 grey-text">{subTitle}</p>}
        </div>
      </div>

      <img
        alt="note icon"
        className="mr-4 new-note-chevron"
        src={images("./common/right-chevron.svg")}
      />
    </li>
  );
}
